import { actions } from './actions'

const initialState = {
  fechasNoEntrega: {
    data: [],
    loading: false,
    error: '',
  },
  fechaNoEntrega: {
    data: null,
    loading: false,
    error: '',
  },
  fechasNoEntregaProvincia: {
    data: null,
    loading: false,
    error: '',
  },
  fechasNoEntregaCategoriaPerso: {
    data: null,
    loading: false,
    error: '',
  },
  fechasNoEntregaCategoriasPersonalizadaDia: {
    data: null,
    loading: false,
    error: '',
  },
  dias: {
    data: null,
    loading: false,
    error: '',
  },
  configuracionCategoria: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function fechaNoEntregaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FECHA_NO_ENTREGA_LOAD_REQUESTED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: true },
      }
    case actions.FECHA_NO_ENTREGA_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, data: action.payload, loading: false },
      }
    case actions.FECHA_NO_ENTREGA_LOAD_FILED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: false, error: action.error },
      }
    case actions.FECHA_NO_ENTREGA_BY_ID_LOAD_REQUESTED:
      return {
        ...state,
        fechaNoEntrega: { ...state.fechaNoEntrega, loading: true },
      }
    case actions.FECHA_NO_ENTREGA_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        fechaNoEntrega: { ...state.fechaNoEntrega, data: action.payload, loading: false },
      }
    case actions.FECHA_NO_ENTREGA_BY_ID_LOAD_FILED:
      return {
        ...state,
        fechaNoEntrega: { ...state.fechaNoEntrega, loading: false, error: action.error },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_REQUESTED:
      return {
        ...state,
        fechasNoEntregaProvincia: { ...state.fechasNoEntregaProvincia, loading: true },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaProvincia: {
          ...state.fechasNoEntregaProvincia,
          data: action.payload,
          loading: false,
        },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_FILED:
      return {
        ...state,
        fechasNoEntregaProvincia: {
          ...state.fechasNoEntregaProvincia,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_INSERT_REQUESTED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: true, error: '' },
      }
    case actions.FECHA_NO_ENTREGA_INSERT_SUCCEEDED:
      return {
        ...state,
        fechasNoEntrega: {
          ...state.fechasNoEntrega,
          data: [].concat(action.payload, state.fechasNoEntrega.data),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_INSERT_FILED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: false, error: action.error },
      }

    case actions.FECHA_NO_ENTREGA_UPDATE_REQUESTED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: true, error: '' },
      }
    case actions.FECHA_NO_ENTREGA_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntrega: {
          ...state.fechasNoEntrega,
          data: state.fechasNoEntrega.data.map(fecha =>
            fecha.id === action.payload.id ? action.payload : fecha,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_UPDATE_FILED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: false, error: action.error },
      }

    case actions.FECHA_NO_ENTREGA_DELETE_REQUESTED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: true, error: '' },
      }
    case actions.FECHA_NO_ENTREGA_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntrega: {
          ...state.fechasNoEntrega,
          data: state.fechasNoEntrega.data.filter(fecha => fecha.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_DELETE_FILED:
      return {
        ...state,
        fechasNoEntrega: { ...state.fechasNoEntrega, loading: false, error: action.error },
      }

    case actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_REQUESTED:
      return {
        ...state,
        fechasNoEntregaProvincia: { ...state.fechasNoEntregaProvincia, loading: true, error: '' },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaProvincia: {
          ...state.fechasNoEntregaProvincia,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_FILED:
      return {
        ...state,
        fechasNoEntregaProvincia: {
          ...state.fechasNoEntregaProvincia,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_REQUESTED:
      return {
        ...state,
        fechasNoEntregaProvincia: { ...state.fechasNoEntregaProvincia, loading: true, error: '' },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaProvincia: {
          ...state.fechasNoEntregaProvincia,
          data: [],
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_FILED:
      return {
        ...state,
        fechasNoEntregaProvincia: {
          ...state.fechasNoEntregaProvincia,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_REQUESTED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: { ...state.fechasNoEntregaCategoriaPerso, loading: true },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          data: action.payload,
          loading: false,
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_FILED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_REQUESTED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          loading: true,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          data: state.fechasNoEntregaCategoriaPerso.data
            .concat(action.payload)
            .map(fecha =>
              fecha.categoriaPersonalizadoId === action.payload.categoriaPersonalizadoId
                ? action.payload
                : fecha,
            ),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_FILED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          loading: false,
          error: action.error,
        },
      }

    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_REQUESTED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          loading: true,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          data: state.fechasNoEntregaCategoriaPerso.data.filter(
            fecha => fecha.categoriaPersonalizadoId !== action.payload.categoriaPersonalizadoId,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_FILED:
      return {
        ...state,
        fechasNoEntregaCategoriaPerso: {
          ...state.fechasNoEntregaCategoriaPerso,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_REQUESTED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          loading: true,
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          data: action.payload,
          loading: false,
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_FILED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_DIAS_LOAD_REQUESTED:
      return {
        ...state,
        dias: { ...state.dias, loading: true },
      }
    case actions.FECHA_NO_ENTREGA_DIAS_LOAD_SUCCEEDED:
      return {
        ...state,
        dias: {
          ...state.dias,
          data: action.payload,
          loading: false,
        },
      }
    case actions.FECHA_NO_ENTREGA_DIAS_LOAD_FILED:
      return {
        ...state,
        dias: {
          ...state.dias,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_DIA_UPDATE_REQUESTED:
      return {
        ...state,
        dias: { ...state.dias, loading: true, error: '' },
      }
    case actions.FECHA_NO_ENTREGA_DIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        dias: {
          ...state.dias,
          data: state.dias.data.map(dia => (dia.id === action.payload.id ? action.payload : dia)),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_DIA_UPDATE_FILED:
      return {
        ...state,
        dias: { ...state.dias, loading: false, error: action.error },
      }
    case actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_REQUESTED:
      return {
        ...state,
        configuracionCategoria: { ...state.configuracionCategoria, loading: true },
      }
    case actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_SUCCEEDED:
      return {
        ...state,
        configuracionCategoria: {
          ...state.configuracionCategoria,
          data: action.payload,
          loading: false,
        },
      }
    case actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_FILED:
      return {
        ...state,
        configuracionCategoria: {
          ...state.configuracionCategoria,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_REQUESTED:
      return {
        ...state,
        configuracionCategoria: { ...state.configuracionCategoria, loading: true, error: '' },
      }
    case actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        configuracionCategoria: {
          ...state.configuracionCategoria,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_FILED:
      return {
        ...state,
        configuracionCategoria: {
          ...state.configuracionCategoria,
          loading: false,
          error: action.error,
        },
      }

    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_REQUESTED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          loading: true,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          data: [],
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_FILED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          loading: false,
          error: action.error,
        },
      }

    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_REQUESTED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          loading: true,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_FILED:
      return {
        ...state,
        fechasNoEntregaCategoriasPersonalizadaDia: {
          ...state.fechasNoEntregaCategoriasPersonalizadaDia,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
